export const normalizeUniqueValue = (value = "") => String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

export const isDuplicateRecord = ({
    rows = [],
    value,
    currentId = null,
    getValue = (row) => row?.name,
    scope = null,
    getScope = null,
}) => {
    const target = normalizeUniqueValue(value);
    if (!target) return false;
    const targetScope = getScope ? normalizeUniqueValue(scope ?? "") : null;
    return (Array.isArray(rows) ? rows : []).some((row) => {
        if (currentId !== null && currentId !== undefined && String(row?.id) === String(currentId)) return false;
        if (getScope && normalizeUniqueValue(getScope(row) ?? "") !== targetScope) return false;
        return normalizeUniqueValue(getValue(row)) === target;
    });
};
